<div #titleBar class="title">
	<span #warnIcon class="title-icon stateful req-warning fa fa-exclamation warn-color"></span>
	<span #infoIcon class="title-icon stateful req-info fa fa-info info-color-lighter"></span>
	<span #confirmIcon class="title-icon stateful req-confirm fa fa-question confirm-color"></span>
	<span #progIcon class="title-icon stateful req-progress fa fa-cog fa-spin info-color-lighter"></span>
	<span #progDoneIcon class="title-icon stateful req-prog-done fa fa-cog  success-color"></span>
	<span #exportIcon class="title-icon stateful req-request-export fa fa-save  info-color-lighter"></span>
	<span #loginIcon class="title-icon stateful req-login fa fa-user-lock"></span>
  <span #importIcon
		class="title-icon stateful req-request-import fa fa-save fa-rotate-180  info-color-lighter"></span>
	<label #modalTitle></label>
	<button type="button" class="close hidden" aria-label="Close">
		<!--(click)="modal.dismiss('Cross click')"-->
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="work-space">
	<p #message></p>
  <app-login-form  #loginForm class="stateful req-login"></app-login-form>
	<div class="progress hidden" #barData>
		<div class="progress-bar" role="progressbar" style="width: 0%" aria-valuenow="0" aria-valuemin="0"
			aria-valuemax="100" #progressBar></div>
	</div>
	<div class="stateful req-request-import" #requestImportUI>

		<div class="input-group">
			<input [(ngModel)]="fileName" class="form-control-file" type="file" [accept]="this.fileAccept"
				(change)="HandleFile($event)">

		</div>

	</div>
	<div class="stateful req-request-export" #requestExportUI>
		<div class="input-group">
			<label>File Name</label>
			<input #exportFileName type="text" class="form-control ml-2" (change)="UpdateFileName()">
			<div class="input-group-append">
				<span class="input-group-text" #extensionSpan [innerText]="fileExt"></span>
			</div>
		</div>
		<div class="input-group">

		</div>
	</div>
</div>
<div class="footer">
  <a class="stateful req-request-import btn btn-md btn-primary import-button" #importAnchor (click)="HandleImport()" [class.disabled]="fileName === ''">Import</a>
  <a class="stateful req-request-export btn btn-md btn-primary export-button" #downloadAnchor (click)="ExportClicked()">Export</a>
  <button type="button" class="btn btn-primary" data-dismiss="modal" #buttonOne>Ok</button>
	<button type="button" class="btn btn-primary hidden" data-dismiss="modal" #buttonTwo>Close</button>
</div>
